// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3E%3Cpath fill=%27%236b7280%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 20px;
  box-sizing: border-box;
}

.status-display {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 15px 0;
}
.status-display.cancelled-status {
  border-left: 4px solid #dc3545;
  background: #fff5f5;
}
.status-display .status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin-left: 8px;
}
.status-display .status-badge.cancelled {
  background: #dc3545;
  color: white;
}
.status-display .status-note {
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #666;
  font-style: italic;
}

.cancellation-remark-section {
  margin: 15px 0;
  padding: 15px;
  background: #fff8f0;
  border-left: 4px solid #ff9800;
  border-radius: 4px;
}
.cancellation-remark-section label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}
.cancellation-remark-section .cancellation-remark-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  min-height: 60px;
  box-sizing: border-box;
}
.cancellation-remark-section .cancellation-remark-textarea:focus {
  outline: none;
  border-color: #ff9800;
  box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.1);
}
.cancellation-remark-section .cancellation-remark-textarea::placeholder {
  color: #888;
}

.cancellation-remark-display {
  margin-top: 15px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
}
.cancellation-remark-display strong {
  color: #495057;
  font-size: 14px;
  display: block;
  margin-bottom: 8px;
}
.cancellation-remark-display .remark-text {
  margin: 0;
  color: #6c757d;
  font-size: 13px;
  line-height: 1.4;
  background: white;
  padding: 8px 12px;
  border-radius: 3px;
  border: 1px solid #e9ecef;
}
.cancellation-remark-display .remark-text.no-remark {
  font-style: italic;
  color: #adb5bd;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  width: 700px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow-y: auto;
  gap: 20px;
  border: 1px solid #e5e7eb;
  position: relative;
}
.confirmation-modal.notinvoice {
  width: 420px;
}
.confirmation-modal.notinvoice .branch-form-close-button {
  top: 12px;
  right: 12px;
}
.confirmation-modal::-webkit-scrollbar {
  width: 6px;
}
.confirmation-modal::-webkit-scrollbar-track {
  background: #f3f4f6;
}
.confirmation-modal::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
.confirmation-modal > p {
  font-size: 18px;
  color: #1f2937;
  margin: 0;
  line-height: 1.5;
  font-weight: 600;
  text-align: center;
}
.confirmation-modal .notinvoicep {
  text-align: left;
}
.confirmation-modal .status-select {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  font-weight: 500;
  appearance: none;
  background: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s ease;
  color: #374151;
}
.confirmation-modal .status-select:hover {
  border-color: #6b7280;
}
.confirmation-modal .status-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.payment-section {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.payment-section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 6px;
  margin: 0;
}
.payment-section .amount-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #374151;
  background: #f9fafb;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 600;
  border: 1px solid #e5e7eb;
}
.payment-section .amount-info > div {
  display: flex;
  align-items: center;
  gap: 4px;
}
.payment-section .amount-info > div strong {
  color: #1f2937;
}
.payment-section .new-payment-form {
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.payment-section .new-payment-form h4 {
  margin: 0 0 16px 0;
  padding: 16px 16px 0;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}
.payment-section .new-payment-form .payment-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  padding: 0 16px 16px;
}
.payment-section .new-payment-form .payment-row .pay-form-group {
  display: flex;
  flex-direction: column;
}
.payment-section .new-payment-form .payment-row .pay-form-group label {
  font-size: 12px;
  color: #374151;
  margin-bottom: 4px;
  font-weight: 600;
}
.payment-section .new-payment-form .payment-row .pay-form-group select,
.payment-section .new-payment-form .payment-row .pay-form-group input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  background: #ffffff;
  color: #374151;
}
.payment-section .new-payment-form .payment-row .pay-form-group select:hover,
.payment-section .new-payment-form .payment-row .pay-form-group input:hover {
  border-color: #6b7280;
}
.payment-section .new-payment-form .payment-row .pay-form-group select:focus,
.payment-section .new-payment-form .payment-row .pay-form-group input:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.payment-section .new-payment-form .payment-row .pay-form-group select:disabled,
.payment-section .new-payment-form .payment-row .pay-form-group input:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}
.payment-section .new-payment-form .payment-row .pay-form-group select::placeholder,
.payment-section .new-payment-form .payment-row .pay-form-group input::placeholder {
  color: #9ca3af;
}
.payment-section .new-payment-form .payment-row .pay-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  cursor: pointer;
}

.previous-payments,
.view-only-mode {
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.previous-payments h4,
.view-only-mode h4 {
  margin: 0 0 12px 0;
  padding: 12px 16px 0;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}
.previous-payments .payments-table-container,
.view-only-mode .payments-table-container {
  max-height: 200px;
  overflow-y: auto;
  margin: 0 16px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}
.previous-payments .payments-table-container::-webkit-scrollbar,
.view-only-mode .payments-table-container::-webkit-scrollbar {
  width: 4px;
}
.previous-payments .payments-table-container::-webkit-scrollbar-thumb,
.view-only-mode .payments-table-container::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 2px;
}
.previous-payments .payments-table-container::-webkit-scrollbar-track,
.view-only-mode .payments-table-container::-webkit-scrollbar-track {
  background: #f3f4f6;
}
.previous-payments .payments-table,
.view-only-mode .payments-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin: 0;
}
.previous-payments .payments-table th, .previous-payments .payments-table td,
.view-only-mode .payments-table th,
.view-only-mode .payments-table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
}
.previous-payments .payments-table th,
.view-only-mode .payments-table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 11px;
}
.previous-payments .payments-table td,
.view-only-mode .payments-table td {
  color: #6b7280;
  background-color: white;
  font-weight: 500;
}
.previous-payments .payments-table tr:hover td,
.view-only-mode .payments-table tr:hover td {
  background: #f9fafb;
}
.previous-payments .payments-table tr:last-child td,
.view-only-mode .payments-table tr:last-child td {
  border-bottom: none;
}
.previous-payments .payments-table .download-receipt-btn,
.view-only-mode .payments-table .download-receipt-btn {
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}
.previous-payments .payments-table .download-receipt-btn:hover,
.view-only-mode .payments-table .download-receipt-btn:hover {
  background: #059669;
}
.previous-payments .payments-table .download-receipt-btn:active,
.view-only-mode .payments-table .download-receipt-btn:active {
  background: #047857;
}
.previous-payments .payments-table th:nth-child(1), .previous-payments .payments-table td:nth-child(1),
.view-only-mode .payments-table th:nth-child(1),
.view-only-mode .payments-table td:nth-child(1) {
  width: 15%;
}
.previous-payments .payments-table th:nth-child(2), .previous-payments .payments-table td:nth-child(2),
.view-only-mode .payments-table th:nth-child(2),
.view-only-mode .payments-table td:nth-child(2) {
  width: 15%;
}
.previous-payments .payments-table th:nth-child(3), .previous-payments .payments-table td:nth-child(3),
.view-only-mode .payments-table th:nth-child(3),
.view-only-mode .payments-table td:nth-child(3) {
  width: 12%;
}
.previous-payments .payments-table th:nth-child(4), .previous-payments .payments-table td:nth-child(4),
.view-only-mode .payments-table th:nth-child(4),
.view-only-mode .payments-table td:nth-child(4) {
  width: 15%;
}
.previous-payments .payments-table th:nth-child(5), .previous-payments .payments-table td:nth-child(5),
.view-only-mode .payments-table th:nth-child(5),
.view-only-mode .payments-table td:nth-child(5) {
  width: 15%;
}
.previous-payments .payments-table th:nth-child(6), .previous-payments .payments-table td:nth-child(6),
.view-only-mode .payments-table th:nth-child(6),
.view-only-mode .payments-table td:nth-child(6) {
  width: 20%;
}
.previous-payments .payments-table th:nth-child(7), .previous-payments .payments-table td:nth-child(7),
.view-only-mode .payments-table th:nth-child(7),
.view-only-mode .payments-table td:nth-child(7) {
  width: 8%;
  text-align: center;
}

.no-transactions {
  text-align: center;
  padding: 3rem 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 1rem 0;
}
.no-transactions p {
  color: #6c757d;
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}
.confirmation-actions.notinvoice {
  border-top: none;
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover {
  background: var(--primary-color);
  opacity: 0.9;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover {
  background: #4b5563;
}
.confirmation-actions .cancel-btn:active {
  background: #374151;
}

@media (max-width: 768px) {
  .confirmation-modal {
    width: 95%;
    padding: 20px;
    gap: 16px;
  }
  .confirmation-modal > p {
    font-size: 16px;
  }
  .confirmation-modal .payment-section {
    gap: 14px;
  }
  .confirmation-modal .payment-section .amount-info {
    flex-direction: column;
    gap: 4px;
    text-align: center;
    font-size: 13px;
  }
  .confirmation-modal .payment-section .new-payment-form .payment-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .confirmation-modal .payment-section .new-payment-form .payment-row .pay-form-group select,
  .confirmation-modal .payment-section .new-payment-form .payment-row .pay-form-group input {
    padding: 10px 12px;
    font-size: 14px;
  }
  .confirmation-modal .confirmation-actions .confirm-btn,
  .confirmation-modal .confirmation-actions .cancel-btn {
    flex: 1 1;
    padding: 12px 16px;
  }
  .previous-payments .payments-table-container,
  .view-only-mode .payments-table-container {
    max-height: 300px;
  }
  .previous-payments .payments-table,
  .view-only-mode .payments-table {
    font-size: 10px;
  }
  .previous-payments .payments-table th, .previous-payments .payments-table td,
  .view-only-mode .payments-table th,
  .view-only-mode .payments-table td {
    padding: 6px 4px;
  }
  .previous-payments .payments-table .download-receipt-btn,
  .view-only-mode .payments-table .download-receipt-btn {
    padding: 3px 6px;
    font-size: 9px;
  }
  .previous-payments h4,
  .view-only-mode h4 {
    font-size: 13px;
    padding: 10px 12px 0;
  }
  .no-transactions {
    padding: 2rem 1rem;
  }
  .no-transactions p {
    font-size: 14px;
  }
}
.branch-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.branch-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.branch-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/ConfirmModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACE,8BAAA;EACA,mBAAA;AACJ;AAEE;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,mBAAA;EACA,YAAA;AAAN;AAIE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAHF;AAKE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAHJ;AAME;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAJJ;AAMI;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAJN;AAOI;EACE,WAAA;AALN;;AAUA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAPF;AASE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAPJ;AAUE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AARJ;AAUI;EACE,kBAAA;EACA,cAAA;AARN;;AAaA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AAVF;AAYE;EACI,YAAA;AAVN;AAYM;EACE,SAAA;EACA,WAAA;AAVR;AAcE;EACE,UAAA;AAZJ;AAeE;EACE,mBAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,gBAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;EACA,cAAA;AAjBJ;AAmBI;EACE,qBAAA;AAjBN;AAoBI;EACE,qBAAA;EACA,6CAAA;AAlBN;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApBF;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,SAAA;AApBJ;AAuBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AArBJ;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArBN;AAuBM;EACE,cAAA;AArBR;AA0BE;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;AAxBJ;AA0BI;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxBN;AA2BI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,oBAAA;AAzBN;AA2BM;EACE,aAAA;EACA,sBAAA;AAzBR;AA2BQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAzBV;AA4BQ;;EAEE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;AA1BV;AA4BU;;EACE,qBAAA;AAzBZ;AA4BU;;EACE,qBAAA;EACA,aAAA;EACA,6CAAA;AAzBZ;AA4BU;;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AAzBZ;AA4BU;;EACE,cAAA;AAzBZ;AA6BQ;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,qCAAA;EACA,qBAAA;EACA,eAAA;AA3BV;;AAmCA;;EAEE,mBAAA;EACA,kBAAA;EACA,yBAAA;AAhCF;AAkCE;;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/BJ;AAkCE;;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA/BJ;AAiCI;;EACE,UAAA;AA9BN;AAiCI;;EACE,mBAAA;EACA,kBAAA;AA9BN;AAiCI;;EACE,mBAAA;AA9BN;AAkCE;;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AA/BJ;AAiCI;;;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;AA7BN;AAgCI;;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AA7BN;AAgCI;;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;AA7BN;AAgCI;;EACE,mBAAA;AA7BN;AAgCI;;EACE,mBAAA;AA7BN;AAgCI;;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AA7BN;AA+BM;;EACE,mBAAA;AA5BR;AA+BM;;EACE,mBAAA;AA5BR;AAgCI;;;EAAmC,UAAA;AA3BvC;AA4BI;;;EAAmC,UAAA;AAvBvC;AAwBI;;;EAAmC,UAAA;AAnBvC;AAoBI;;;EAAmC,UAAA;AAfvC;AAgBI;;;EAAmC,UAAA;AAXvC;AAYI;;;EAAmC,UAAA;AAPvC;AAQI;;;EACE,SAAA;EACA,kBAAA;AAJN;;AASA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AANF;AAQE;EACE,cAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAPF;AASE;EACE,gBAAA;AAPJ;AAUE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AARJ;AAWE;EACE,gCAAA;EACA,YAAA;AATJ;AAWI;EACE,gCAAA;EACA,YAAA;AATN;AAaE;EACE,mBAAA;EACA,YAAA;AAXJ;AAaI;EACE,mBAAA;AAXN;AAcI;EACE,mBAAA;AAZN;;AAkBA;EACE;IACE,UAAA;IACA,aAAA;IACA,SAAA;EAfF;EAiBE;IACE,eAAA;EAfJ;EAkBE;IACE,SAAA;EAhBJ;EAkBI;IACE,sBAAA;IACA,QAAA;IACA,kBAAA;IACA,eAAA;EAhBN;EAmBI;IACE,0BAAA;IACA,SAAA;EAjBN;EAoBQ;;IAEE,kBAAA;IACA,eAAA;EAlBV;EAyBI;;IAEE,SAAA;IACA,kBAAA;EAvBN;EA8BE;;IACE,iBAAA;EA3BJ;EA8BE;;IACE,eAAA;EA3BJ;EA6BI;;;IACE,gBAAA;EAzBN;EA4BI;;IACE,gBAAA;IACA,cAAA;EAzBN;EA6BE;;IACE,eAAA;IACA,oBAAA;EA1BJ;EA8BA;IACE,kBAAA;EA5BF;EA8BE;IACE,eAAA;EA5BJ;AACF;AAgCA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AA9BF;AAgCE;EACE,yBAAA;EACA,cAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,6CAAA;AA/BJ","sourcesContent":[".confirmation-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 999;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.status-display {\r\n  padding: 15px;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  margin: 15px 0;\r\n  \r\n  &.cancelled-status {\r\n    border-left: 4px solid #dc3545;\r\n    background: #fff5f5;\r\n  }\r\n  \r\n  .status-badge {\r\n    display: inline-block;\r\n    padding: 4px 12px;\r\n    border-radius: 20px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    margin-left: 8px;\r\n    \r\n    &.cancelled {\r\n      background: #dc3545;\r\n      color: white;\r\n    }\r\n  }\r\n  \r\n  .status-note {\r\n    margin: 8px 0 0 0;\r\n    font-size: 14px;\r\n    color: #666;\r\n    font-style: italic;\r\n  }\r\n}\r\n\r\n.cancellation-remark-section {\r\n  margin: 15px 0;\r\n  padding: 15px;\r\n  background: #fff8f0;\r\n  border-left: 4px solid #ff9800;\r\n  border-radius: 4px;\r\n  \r\n  label {\r\n    display: block;\r\n    font-weight: 600;\r\n    margin-bottom: 8px;\r\n    color: #333;\r\n  }\r\n  \r\n  .cancellation-remark-textarea {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-family: inherit;\r\n    font-size: 14px;\r\n    resize: vertical;\r\n    min-height: 60px;\r\n    box-sizing: border-box;\r\n    \r\n    &:focus {\r\n      outline: none;\r\n      border-color: #ff9800;\r\n      box-shadow: 0 0 0 2px rgba(255, 152, 0, 0.1);\r\n    }\r\n    \r\n    &::placeholder {\r\n      color: #888;\r\n    }\r\n  }\r\n}\r\n\r\n.cancellation-remark-display {\r\n  margin-top: 15px;\r\n  padding: 12px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 4px;\r\n\r\n  strong {\r\n    color: #495057;\r\n    font-size: 14px;\r\n    display: block;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .remark-text {\r\n    margin: 0;\r\n    color: #6c757d;\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n    background: white;\r\n    padding: 8px 12px;\r\n    border-radius: 3px;\r\n    border: 1px solid #e9ecef;\r\n\r\n    &.no-remark {\r\n      font-style: italic;\r\n      color: #adb5bd;\r\n    }\r\n  }\r\n}\r\n\r\n.confirmation-modal {\r\n  background: #ffffff;\r\n  padding: 24px;\r\n  border-radius: 8px;\r\n  width: 700px;\r\n  max-width: 95%;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 85vh;\r\n  overflow-y: auto;\r\n  gap: 20px;\r\n  border: 1px solid #e5e7eb;\r\n  position: relative;\r\n\r\n  &.notinvoice{\r\n      width: 420px;\r\n\r\n      .branch-form-close-button {\r\n        top: 12px;\r\n        right: 12px;\r\n     }\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: #f3f4f6;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: #d1d5db;\r\n    border-radius: 3px;\r\n  }\r\n\r\n  > p {\r\n    font-size: 18px;\r\n    color: #1f2937;\r\n    margin: 0;\r\n    line-height: 1.5;\r\n    font-weight: 600;\r\n    text-align: center;\r\n  }\r\n  \r\n  .notinvoicep{\r\n    text-align: left;\r\n  }\r\n\r\n  .status-select {\r\n    width: 100%;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    border: 1px solid #d1d5db;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    appearance: none;\r\n    background: #ffffff;\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%236b7280' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'/%3E%3C/svg%3E\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 12px center;\r\n    background-size: 16px;\r\n    cursor: pointer;\r\n    outline: none;\r\n    transition: border-color 0.2s ease;\r\n    color: #374151;\r\n\r\n    &:hover {\r\n      border-color: #6b7280;\r\n    }\r\n\r\n    &:focus {\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n.payment-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n\r\n  .section-title {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    border-bottom: 2px solid #e5e7eb;\r\n    padding-bottom: 6px;\r\n    margin: 0;\r\n  }\r\n\r\n  .amount-info {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: #374151;\r\n    background: #f9fafb;\r\n    padding: 12px 16px;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    border: 1px solid #e5e7eb;\r\n\r\n    > div {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 4px;\r\n\r\n      strong {\r\n        color: #1f2937;\r\n      }\r\n    }\r\n  }\r\n\r\n  .new-payment-form {\r\n    background: #f9fafb;\r\n    border-radius: 8px;\r\n    border: 1px solid #e5e7eb;\r\n    \r\n    h4 {\r\n      margin: 0 0 16px 0;\r\n      padding: 16px 16px 0;\r\n      color: #374151;\r\n      font-size: 14px;\r\n      font-weight: 600;\r\n    }\r\n\r\n    .payment-row {\r\n      display: grid;\r\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n      gap: 12px;\r\n      padding: 0 16px 16px;\r\n\r\n      .pay-form-group {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        label {\r\n          font-size: 12px;\r\n          color: #374151;\r\n          margin-bottom: 4px;\r\n          font-weight: 600;\r\n        }\r\n\r\n        select,\r\n        input {\r\n          padding: 8px 12px;\r\n          border: 1px solid #d1d5db;\r\n          border-radius: 6px;\r\n          font-size: 13px;\r\n          font-weight: 500;\r\n          width: 100%;\r\n          box-sizing: border-box;\r\n          transition: border-color 0.2s ease;\r\n          background: #ffffff;\r\n          color: #374151;\r\n\r\n          &:hover {\r\n            border-color: #6b7280;\r\n          }\r\n\r\n          &:focus {\r\n            border-color: #3b82f6;\r\n            outline: none;\r\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n          }\r\n\r\n          &:disabled {\r\n            background: #f3f4f6;\r\n            color: #9ca3af;\r\n            cursor: not-allowed;\r\n          }\r\n\r\n          &::placeholder {\r\n            color: #9ca3af;\r\n          }\r\n        }\r\n\r\n        select {\r\n          appearance: none;\r\n          background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%236b7280' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'/%3E%3C/svg%3E\");\r\n          background-repeat: no-repeat;\r\n          background-position: right 8px center;\r\n          background-size: 12px;\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Common styles for both .previous-payments and .view-only-mode\r\n.previous-payments,\r\n.view-only-mode {\r\n  background: #f9fafb;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n  \r\n  h4 {\r\n    margin: 0 0 12px 0;\r\n    padding: 12px 16px 0;\r\n    color: #374151;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .payments-table-container {\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    margin: 0 16px 16px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 6px;\r\n    background: white;\r\n    \r\n    &::-webkit-scrollbar {\r\n      width: 4px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: #d1d5db;\r\n      border-radius: 2px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: #f3f4f6;\r\n    }\r\n  }\r\n  \r\n  .payments-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 12px;\r\n    margin: 0;\r\n    \r\n    th, td {\r\n      padding: 8px 10px;\r\n      text-align: left;\r\n      border-bottom: 1px solid #f3f4f6;\r\n    }\r\n    \r\n    th {\r\n      background: #f9fafb;\r\n      font-weight: 600;\r\n      color: #374151;\r\n      position: sticky;\r\n      top: 0;\r\n      z-index: 1;\r\n      font-size: 11px;\r\n    }\r\n    \r\n    td {\r\n      color: #6b7280;\r\n      background-color: white;\r\n      font-weight: 500;\r\n    }\r\n    \r\n    tr:hover td {\r\n      background: #f9fafb;\r\n    }\r\n\r\n    tr:last-child td {\r\n      border-bottom: none;\r\n    }\r\n\r\n    .download-receipt-btn {\r\n      background: #10b981;\r\n      color: white;\r\n      border: none;\r\n      border-radius: 4px;\r\n      padding: 4px 8px;\r\n      cursor: pointer;\r\n      font-size: 11px;\r\n      font-weight: 500;\r\n      transition: background-color 0.2s ease;\r\n      \r\n      &:hover {\r\n        background: #059669;\r\n      }\r\n      \r\n      &:active {\r\n        background: #047857;\r\n      }\r\n    }\r\n\r\n    th:nth-child(1), td:nth-child(1) { width: 15%; }\r\n    th:nth-child(2), td:nth-child(2) { width: 15%; }\r\n    th:nth-child(3), td:nth-child(3) { width: 12%; }\r\n    th:nth-child(4), td:nth-child(4) { width: 15%; }\r\n    th:nth-child(5), td:nth-child(5) { width: 15%; }\r\n    th:nth-child(6), td:nth-child(6) { width: 20%; }\r\n    th:nth-child(7), td:nth-child(7) { \r\n      width: 8%; \r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n\r\n.no-transactions {\r\n  text-align: center;\r\n  padding: 3rem 2rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  margin: 1rem 0;\r\n\r\n  p {\r\n    color: #6c757d;\r\n    font-size: 16px;\r\n    margin: 0;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.confirmation-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #e5e7eb;\r\n\r\n  &.notinvoice{\r\n    border-top: none;\r\n  }\r\n\r\n  .confirm-btn,\r\n  .cancel-btn {\r\n    padding: 8px 18px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    min-width: 80px;\r\n  }\r\n\r\n  .confirm-btn {\r\n    background: var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover {\r\n      background: var(--primary-color);\r\n      opacity: 0.9;\r\n    }\r\n  }\r\n\r\n  .cancel-btn {\r\n    background: #6b7280;\r\n    color: white;\r\n\r\n    &:hover {\r\n      background: #4b5563;\r\n    }\r\n\r\n    &:active {\r\n      background: #374151;\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive design\r\n@media (max-width: 768px) {\r\n  .confirmation-modal {\r\n    width: 95%;\r\n    padding: 20px;\r\n    gap: 16px;\r\n\r\n    > p {\r\n      font-size: 16px;\r\n    }\r\n\r\n    .payment-section {\r\n      gap: 14px;\r\n\r\n      .amount-info {\r\n        flex-direction: column;\r\n        gap: 4px;\r\n        text-align: center;\r\n        font-size: 13px;\r\n      }\r\n\r\n      .new-payment-form .payment-row {\r\n        grid-template-columns: 1fr;\r\n        gap: 10px;\r\n\r\n        .pay-form-group {\r\n          select,\r\n          input {\r\n            padding: 10px 12px;\r\n            font-size: 14px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .confirmation-actions {\r\n      .confirm-btn,\r\n      .cancel-btn {\r\n        flex: 1;\r\n        padding: 12px 16px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .previous-payments,\r\n  .view-only-mode {\r\n    .payments-table-container {\r\n      max-height: 300px;\r\n    }\r\n\r\n    .payments-table {\r\n      font-size: 10px;\r\n      \r\n      th, td {\r\n        padding: 6px 4px;\r\n      }\r\n      \r\n      .download-receipt-btn {\r\n        padding: 3px 6px;\r\n        font-size: 9px;\r\n      }\r\n    }\r\n\r\n    h4 {\r\n      font-size: 13px;\r\n      padding: 10px 12px 0;\r\n    }\r\n  }\r\n\r\n  .no-transactions {\r\n    padding: 2rem 1rem;\r\n\r\n    p {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\n\r\n.branch-form-close-button {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1rem;\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  z-index: 1001;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.25rem;\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover {\r\n    background-color: #f3f4f6;\r\n    color: #374151;\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
